import { Box, Typography } from "@mui/material";
import Input from "models/input/input";
import React from "react";

const ProjectInfo = ({
  input,
}: Readonly<{
  input: Input;
}>) => {
  return (
    <>
      {/* <Box p={1} width="100%">
        <Typography variant="subtitle2">
          <b>Input id</b>:
        </Typography>
        <Typography color="initial">{input.input_id}</Typography>
      </Box> */}
      {process.env.REACT_APP_STYLING_THEME == "" && (
        <Box p={1} width="100%">
          <Typography variant="subtitle2">
            <b>Domain</b>:
          </Typography>
          <Typography color="initial">{input.domain}</Typography>
        </Box>
      )}
      <Box p={1} width="100%">
        <Typography variant="subtitle2">
          <b>Project name</b>:
        </Typography>
        <Typography color="initial">{input.project}</Typography>
      </Box>
    </>
  );
};

export default ProjectInfo;
